import Grid from '@mui/material/Grid2';
import { DetailsGrid } from '../DetailsGrid';
import { useGetGenericDetailsPanels } from '../hooks/useGetGenericDetailsPanels';
import { useFieldFormatting } from '../hooks/useFieldFormatting';
import { OverviewAccordion } from '../ComponentsOverview/OverviewAccordion';
import Stack from '@mui/material/Stack';
import { useAtomValue } from 'jotai';
import * as state from '@/components/Analysis/state';

export const AssessmentDetailsSection = ({
  assemblyId,
  componentName,
}: {
  assemblyId?: string;
  componentName?: string;
}) => {
  const assemblyDetailsById = useAtomValue(state.componentDetailsById);
  const assemblyAreaById = useAtomValue(state.componentAreasById);
  const assemblyDetails = assemblyDetailsById?.[assemblyId ?? ''] ?? {};
  const assemblyArea = assemblyAreaById?.[assemblyId ?? ''] ?? 0;

  const { getFieldName, getFormattedValueDetails } = useFieldFormatting(
    assemblyDetails,
    assemblyArea,
    assemblyId
  );
  const { detailsData, displayableFields } = useGetGenericDetailsPanels(assemblyDetails);

  return (
    <Stack direction="column" gap="2rem" sx={{ width: '100%' }}>
      {assemblyDetails &&
        detailsData &&
        detailsData.map((detail) => (
          <OverviewAccordion
            key={detail.title}
            title={detail.title}
            componentName={componentName ?? ''}
            details={
              <Grid container spacing="2.6rem" sx={{ width: '100%', p: '4rem', pt: '1.4rem' }}>
                <DetailsGrid
                  title=""
                  data={detail.data}
                  getFieldName={getFieldName}
                  getFormattedValue={getFormattedValueDetails}
                  displayableFields={displayableFields}
                  allowEditing={true}
                />
              </Grid>
            }
            defaultExpanded={detail.data.length > 0}
          />
        ))}
    </Stack>
  );
};
